module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst additionalAttributes = []\nconst additionalClasses = []\nconst renderMode = ((storage || {}).request || {}).renderMode || ''\nconst tripAttributes = model.tripAttributes || {}\nconst tripReplacements = model.tripReplacements || {}\nconst offerDate = utils.moment(tripAttributes.offerTS || new Date()).format('DD.MM.YYYY')\nlet tripTimeRange = utils.moment(tripAttributes.tripStart).format('DD.MM.YYYY')\nif(tripAttributes.tripStart && tripAttributes.tripStart !== tripAttributes.tripEnd){\ntripTimeRange = `${tripTimeRange} - ${utils.moment(tripAttributes.tripEnd).format('DD.MM.YYYY')}`\n}\nconst titleParts = []\nif(tripAttributes.tripID)  titleParts.push(`#${tripAttributes.tripID}`);\nif(tripAttributes.title)   titleParts.push(tripAttributes.title);\nconst title = titleParts.join(' ')\nlet targetAddress = ''\nconst targetAddressParts = []\ntargetAddressParts.push(String(tripAttributes.clientAddress || '').replace(/\\n+/g, '<br>'))\nif(tripAttributes.clientTaxNumber) targetAddressParts.push(`UID: ${tripAttributes.clientTaxNumber}`);\ntargetAddress = targetAddressParts.join('<br>')\nif(renderMode === 'html'){\nadditionalClasses.push('styleTableWithoutBackground')\n}\nif(additionalClasses.length > 0){\nadditionalAttributes.push(`class=\"${additionalClasses.join(' ')}\"`)\n}\n%><div <%- additionalAttributes.join(' ') %>>\n<section class=\"controls\">\n<!-- extra management control buttons may be needed in the future -->\n</section>\n<section class=\"sheet\">\n<%- include('./header', { model }) %>\n<section class=\"body\">\n<div class=\"general\">\n<table>\n<tbody>\n<tr>\n<td class=\"targetAddress\"><%- targetAddress %><br><br></td>\n<td class=\"sourceAddress\">&nbsp;</td>\n</tr>\n</tbody>\n<tbody>\n<tr class=\"titleRow\">\n<td class=\"title\"><%= storage.__('document.offer.head') %></td>\n<td class=\"number\">Wels / Auberg, <%= offerDate %></td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td colspan=\"2\" class=\"html-editor-content-format\"><%-\nString(tripAttributes.offerContent || '').replace(new RegExp(/\\[([a-zA-Z\\s-]+)\\]/, 'g'), (match, originalTripKey) => {\nconst tripKey = String(originalTripKey || '').replace(/[\\s-]+/, '').toLowerCase()\nif(tripReplacements[tripKey] || tripReplacements[tripKey] === 0){\nreturn tripReplacements[tripKey]\n} else if(tripKey === 'kostenstellentabelle'){\nreturn include('../invoice/invoicePositions', { model, config: { printSum: false }, })\n}\nreturn '-'\n})\n%></td>\n</tr>\n</tbody>\n</table>\n</div>\n<% if(tripAttributes.status === 'canceled'){ %>\n<div class=\"watermark\">\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"500\" height=\"160\" viewBox=\"0 0 500 160\"><path d=\"M478.5,148.14H24.78c-.94,0-1.88,0-2.82,0-.14,0-.28,0-.42,0a10.28,10.28,0,0,1-7.81-3.9c-2.09-2.93-2-5-2-8.65V85.92c0-21.28-.16-42.57,0-63.85a10,10,0,0,1,9.77-10.2H453c8.38,0,16.76-.06,25.14,0a9.84,9.84,0,0,1,8.72,4.7,9.39,9.39,0,0,1,1.44,5.5V131c0,2.33,0,4.65,0,7a10,10,0,0,1-9.77,10.2c-7.53.17-7.55,12,0,11.85A21.93,21.93,0,0,0,500,138.26c0-1.83,0-3.66,0-5.49V25.29c0-3.28.07-6.54-.89-9.74A21.87,21.87,0,0,0,478.45,0c-2.15,0-4.3,0-6.44,0H22.79c-.87,0-1.73,0-2.6.05A21.93,21.93,0,0,0,.05,21.77c-.12,6.62,0,13.25,0,19.87V134.9c0,3.44,0,6.86,1.09,10.19A21.88,21.88,0,0,0,21.6,160c.66,0,1.32,0,2,0H478.5C486,160,486.06,148.14,478.5,148.14Z\" style=\"fill:#c1272d\"/><text style=\"font-size:80px;fill:#c1272d;font-family:OpenSans-Bold, Open Sans;font-weight:700;\" dy=\"28\" x=\"50%\" y=\"50%\" text-anchor=\"middle\">Storno</text></svg>\n</div>\n<% } %>\n<%- helpers.renderSection('content') %>\n</section>\n<%- include('./footer', { model, useDocumentType: 'offer' }) %>\n</section>\n<section class=\"controls\">\n<!-- extra management control buttons may be needed in the future -->\n</section>\n</div>"
  , __filename = "components/templates/core/documents/offer/offer.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const additionalAttributes = []
const additionalClasses = []
const renderMode = ((storage || {}).request || {}).renderMode || ''
const tripAttributes = model.tripAttributes || {}
const tripReplacements = model.tripReplacements || {}
const offerDate = utils.moment(tripAttributes.offerTS || new Date()).format('DD.MM.YYYY')
let tripTimeRange = utils.moment(tripAttributes.tripStart).format('DD.MM.YYYY')
if(tripAttributes.tripStart && tripAttributes.tripStart !== tripAttributes.tripEnd){
tripTimeRange = `${tripTimeRange} - ${utils.moment(tripAttributes.tripEnd).format('DD.MM.YYYY')}`
}
const titleParts = []
if(tripAttributes.tripID)  titleParts.push(`#${tripAttributes.tripID}`);
if(tripAttributes.title)   titleParts.push(tripAttributes.title);
const title = titleParts.join(' ')
let targetAddress = ''
const targetAddressParts = []
targetAddressParts.push(String(tripAttributes.clientAddress || '').replace(/\n+/g, '<br>'))
if(tripAttributes.clientTaxNumber) targetAddressParts.push(`UID: ${tripAttributes.clientTaxNumber}`);
targetAddress = targetAddressParts.join('<br>')
if(renderMode === 'html'){
additionalClasses.push('styleTableWithoutBackground')
}
if(additionalClasses.length > 0){
additionalAttributes.push(`class="${additionalClasses.join(' ')}"`)
}

    ; __line = 27
    ; __append("<div ")
    ; __append( additionalAttributes.join(' ') )
    ; __append(">\n<section class=\"controls\">\n<!-- extra management control buttons may be needed in the future -->\n</section>\n<section class=\"sheet\">\n")
    ; __line = 32
    ; __append( include('./header', { model }) )
    ; __append("\n<section class=\"body\">\n<div class=\"general\">\n<table>\n<tbody>\n<tr>\n<td class=\"targetAddress\">")
    ; __line = 38
    ; __append( targetAddress )
    ; __append("<br><br></td>\n<td class=\"sourceAddress\">&nbsp;</td>\n</tr>\n</tbody>\n<tbody>\n<tr class=\"titleRow\">\n<td class=\"title\">")
    ; __line = 44
    ; __append(escapeFn( storage.__('document.offer.head') ))
    ; __append("</td>\n<td class=\"number\">Wels / Auberg, ")
    ; __line = 45
    ; __append(escapeFn( offerDate ))
    ; __append("</td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td colspan=\"2\" class=\"html-editor-content-format\">")
    ; __line = 50
    ; __append(
String(tripAttributes.offerContent || '').replace(new RegExp(/\[([a-zA-Z\s-]+)\]/, 'g'), (match, originalTripKey) => {
const tripKey = String(originalTripKey || '').replace(/[\s-]+/, '').toLowerCase()
if(tripReplacements[tripKey] || tripReplacements[tripKey] === 0){
return tripReplacements[tripKey]
} else if(tripKey === 'kostenstellentabelle'){
return include('../invoice/invoicePositions', { model, config: { printSum: false }, })
}
return '-'
})
)
    ; __line = 60
    ; __append("</td>\n</tr>\n</tbody>\n</table>\n</div>\n")
    ; __line = 65
    ;  if(tripAttributes.status === 'canceled'){ 
    ; __append("\n<div class=\"watermark\">\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"500\" height=\"160\" viewBox=\"0 0 500 160\"><path d=\"M478.5,148.14H24.78c-.94,0-1.88,0-2.82,0-.14,0-.28,0-.42,0a10.28,10.28,0,0,1-7.81-3.9c-2.09-2.93-2-5-2-8.65V85.92c0-21.28-.16-42.57,0-63.85a10,10,0,0,1,9.77-10.2H453c8.38,0,16.76-.06,25.14,0a9.84,9.84,0,0,1,8.72,4.7,9.39,9.39,0,0,1,1.44,5.5V131c0,2.33,0,4.65,0,7a10,10,0,0,1-9.77,10.2c-7.53.17-7.55,12,0,11.85A21.93,21.93,0,0,0,500,138.26c0-1.83,0-3.66,0-5.49V25.29c0-3.28.07-6.54-.89-9.74A21.87,21.87,0,0,0,478.45,0c-2.15,0-4.3,0-6.44,0H22.79c-.87,0-1.73,0-2.6.05A21.93,21.93,0,0,0,.05,21.77c-.12,6.62,0,13.25,0,19.87V134.9c0,3.44,0,6.86,1.09,10.19A21.88,21.88,0,0,0,21.6,160c.66,0,1.32,0,2,0H478.5C486,160,486.06,148.14,478.5,148.14Z\" style=\"fill:#c1272d\"/><text style=\"font-size:80px;fill:#c1272d;font-family:OpenSans-Bold, Open Sans;font-weight:700;\" dy=\"28\" x=\"50%\" y=\"50%\" text-anchor=\"middle\">Storno</text></svg>\n</div>\n")
    ; __line = 69
    ;  } 
    ; __append("\n")
    ; __line = 70
    ; __append( helpers.renderSection('content') )
    ; __append("\n</section>\n")
    ; __line = 72
    ; __append( include('./footer', { model, useDocumentType: 'offer' }) )
    ; __append("\n</section>\n<section class=\"controls\">\n<!-- extra management control buttons may be needed in the future -->\n</section>\n</div>")
    ; __line = 77
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/offer/offer.ejs

}